import { CheckOutlined, CloseOutlined } from "@ant-design/icons";
import React from "react";

const { interviewMapping } = require("../../constants/interview.constant");

export const getMappedData = (key) => {
  const data = interviewMapping.find((item) => item.key === key);
  return data ? data.value : key;
};
export const bulkCheckboxesPreview = (formData, keys) => {
  const result = [];
  for (const key of keys) {
    if (formData[key]) {
      result.push(<div><CheckOutlined style={{ fontSize: 10, color: 'green' }} /> {getMappedData(key)}</div>);
    } else {
      result.push(<div><CloseOutlined style={{ fontSize: 10, color: 'red' }} /> {getMappedData(key)}</div>);
    }
  }
  return result;
}
export const groupedCheckboxesPreview = (formData, key, values) => {
  const result = [];
  for( const val of values) {
    if(formData[key] && formData[key].includes(val)) {
      result.push(
        <div><CheckOutlined style={{ fontSize: 10, color: 'green' }} /> {getMappedData(val)}</div>
      );
    } else {
      result.push(
        <div><CloseOutlined style={{ fontSize: 10, color: 'red' }} /> {getMappedData(val)}</div>
      );
    }
  }
  return result;
}

export const singleCheckboxPreview = (formData, key) => {
  return (
    <div style={{paddingLeft: "20px", paddingTop: '10px'}}>
      <h4>{formData[key] ? <div><CheckOutlined style={{ fontSize: 10, color: 'green' }} /> {getMappedData(key)}</div>: <div><CloseOutlined style={{ fontSize: 10, color: 'red' }} /> {getMappedData(key)}</div>}</h4>
    </div>
  )
};

export const prepareFormData = (apiResponse) => {
  const formData = {
    address: apiResponse.basicInfo.address,
    age: apiResponse.basicInfo.age,
    caste: apiResponse.basicInfo.caste,
    contactNumber: apiResponse.basicInfo.contactNumber,
    gender: apiResponse.basicInfo.gender,
    fullName: apiResponse.basicInfo.fullName,
    referrals: apiResponse.basicInfo.referrals?.length > 0 ? apiResponse.basicInfo.referrals.split('|') : [],
    languageSpoken: apiResponse.basicInfo.languageSpoken,
    noOfChildren: apiResponse.basicInfo.noOfChildren,
    personalCode: apiResponse.basicInfo.personalCode,
    religion: apiResponse.basicInfo.religion,
    referencePersonCodeName: apiResponse.basicInfo.referencePersonCodeName,
    maritalStatus: apiResponse.basicInfo.maritalStatus,
    sourceOfLivelihood: apiResponse.basicInfo.sourceOfLivelihood,
    documentStorage: apiResponse.violenceInfo.documentStorage?.split('|'),
    isDocumented: apiResponse.violenceInfo.isDocumented,
    otherDocumentStorage: apiResponse.violenceInfo.otherDocumentStorage,
    otherFormsOfViolence: apiResponse.violenceInfo.otherFormsOfViolence.split('|'),
    otherTypeOfSexualViolence: apiResponse.violenceInfo.otherTypeOfSexualViolence,
    typeOfSexualViolence: apiResponse.violenceInfo.typeOfSexualViolence.split('|'),
    otherFormsOfViolenceNotes: apiResponse.violenceInfo.otherFormsOfViolenceNotes,
    currentImpact_1: apiResponse.currentImpact.currentImpact_1,
    currentImpact_2: apiResponse.currentImpact.currentImpact_2,
    currentImpact_3: apiResponse.currentImpact.currentImpact_3,
    currentImpact_4: apiResponse.currentImpact.currentImpact_4,
    currentImpact_5: apiResponse.currentImpact.currentImpact_5,
    currentImpact_6: apiResponse.currentImpact.currentImpact_6,
    currentImpact_7: apiResponse.currentImpact.currentImpact_7,
    currentImpact_8: apiResponse.currentImpact.currentImpact_8,
    currentImpact_9: apiResponse.currentImpact.currentImpact_9,
    currentImpact_10: apiResponse.currentImpact.currentImpact_10,
    concordance_ack_1: apiResponse.concordanceCard.concordance_ack_1,
    concordance_ack_2: apiResponse.concordanceCard.concordance_ack_2,
    concordance_ack_3: apiResponse.concordanceCard.concordance_ack_3.split('|'),
    acknowledge: apiResponse.acknowledge.acknowledge,
    acknowledge_1: apiResponse.acknowledge.acknowledge_1,
    acknowledge_2: apiResponse.acknowledge.acknowledge_2,
    acknowledge_3: apiResponse.acknowledge.acknowledge_3,
    ackOtherOptions: apiResponse.acknowledge.ackOtherOptions,
    feedbackOtherNotes: apiResponse.feedback.feedbackOtherNotes,
    feedback_ack_1: apiResponse.feedback.feedback_ack_1,
    feedback_ack_2: apiResponse.feedback.feedback_ack_2,
    feedback_ack_2_description: apiResponse.feedback.feedback_ack_2_description,
    feedback_ack_3: apiResponse.feedback.feedback_ack_3,
    feedback_ack_3_description: apiResponse.feedback.feedback_ack_3_description
  };
  if (apiResponse.individualIRMPackage) {
      formData['financialIRM'] = apiResponse.individualIRMPackage.financialIRM.split('|');
      formData['financialIRMDetails'] = apiResponse.individualIRMPackage.financialIRMDetails
      formData['psychologicalIRM'] = apiResponse.individualIRMPackage.psychologicalIRM.split('|');
      formData['psychologicalIRMDetails'] = apiResponse.individualIRMPackage.psychologicalIRMDetails;
      formData['medicalIRM'] = apiResponse.individualIRMPackage.medicalIRM.split('|');
      formData['medicalIRMDetails'] = apiResponse.individualIRMPackage.medicalIRMDetails;
      formData['accompaniment'] = apiResponse.individualIRMPackage.accompaniment;
      formData['closingTheInterview'] = apiResponse.individualIRMPackage.closingTheInterview;
      formData['place'] = apiResponse.individualIRMPackage.place;
  }
  return formData;
};

export const preparePayload = (campaignId, formData) => {
  const payload = {
    "campaignId": parseInt(campaignId),
    "status": "review",
    "draft": formData.draft || false,
  };
  if(formData.gender) {
      payload["basicInfo"] = {
          "fullName": formData.fullName,
          "personalCode": formData.personalCode,
          "address": formData.address,
          "age": formData.age,
          "religion": formData.religion,
          "caste": formData.caste,
          "noOfChildren": parseInt(formData.noOfChildren),
          "sourceOfLivelihood": formData.sourceOfLivelihood,
          "contactNumber": formData.contactNumber,
          "gender": formData.gender,
          "languageSpoken": formData.languageSpoken,
          "referencePersonCodeName": formData.referencePersonCodeName,
          "maritalStatus": formData.maritalStatus,
          "referrals": formData.referrals,
      };
  }
    if(formData.typeOfSexualViolence) {
        payload["violenceInfo"] = {
            "isDocumented": formData.isDocumented,
            "documentStorage": formData.documentStorage,
            "otherDocumentStorage": formData.otherDocumentStorage,
            "typeOfSexualViolence": formData.typeOfSexualViolence,
            "otherTypeOfSexualViolence": formData.otherTypeOfSexualViolence,
            "otherFormsOfViolence": formData.otherFormsOfViolence,
            "otherFormsOfViolenceNotes": formData.otherFormsOfViolenceNotes
        };
    }
    if(formData.currentImpact_1) {
        payload["currentImpact"] = {
            "currentImpact_1": formData.currentImpact_1,
            "currentImpact_2": formData.currentImpact_2,
            "currentImpact_3": formData.currentImpact_3,
            "currentImpact_4": formData.currentImpact_4,
            "currentImpact_5": formData.currentImpact_5,
            "currentImpact_6": formData.currentImpact_6,
            "currentImpact_7": formData.currentImpact_7,
            "currentImpact_8": formData.currentImpact_8,
            "currentImpact_9": formData.currentImpact_9,
            "currentImpact_10": formData.currentImpact_10
        };
    }
    if(formData.concordance_ack_1) {
        payload["concordanceCard"] = {
            "concordance_ack_1": formData.concordance_ack_1,
            "concordance_ack_2": formData.concordance_ack_2,
            "concordance_ack_3": formData.concordance_ack_3
        };
    }
    if(formData.acknowledge) {
        payload["acknowledge"] = {
            "acknowledge": formData.acknowledge,
            "acknowledge_1": formData.acknowledge_1 || false,
            "acknowledge_2": formData.acknowledge_2 || false,
            "acknowledge_3": formData.acknowledge_3 || false,
            "ackOtherOptions": formData.ackOtherOptions || ""
        };
    }
    if(formData.feedback_ack_2_description) {
        payload["feedback"] = {
            "feedback_ack_1": formData.feedback_ack_1 || false,
            "feedback_ack_2": formData.feedback_ack_2 || false,
            "feedback_ack_2_description": formData.feedback_ack_2_description,
            "feedback_ack_3": formData.feedback_ack_3 || false,
            "feedback_ack_3_description": formData.feedback_ack_3_description,
            "feedbackOtherNotes": formData.feedbackOtherNotes
        };
    }
    if(formData.financialIRM) {
        payload["individualIRMPackage"] = {
            "financialIRM": formData.financialIRM,
            "financialIRMDetails": formData.financialIRMDetails,
            "psychologicalIRM": formData.psychologicalIRM,
            "psychologicalIRMDetails": formData.psychologicalIRMDetails,
            "medicalIRM": formData.medicalIRM,
            "medicalIRMDetails": formData.medicalIRMDetails,
            "accompaniment": formData.accompaniment,
            "closingTheInterview": formData.closingTheInterview,
            "place": formData.place
        };
    }
  return payload;
};
